import eventBus from "@/eventBus";
import { OPEN_SNACKBAR } from "@/utils/contants";

export default {
    props: {

    },

    components: {},

    watch: {},

    data() {
        return {
            snackbar: false,
            isError: false,
            text: '',
            timeout: 5000,
        }
    },

    created() { },

    mounted() {
        eventBus.$on(OPEN_SNACKBAR, this.setSnackbarConfig)
    },

    methods: {
        setSnackbarConfig({ message, isError }) {
            this.text = message;
            this.isError = isError;
            this.snackbar = true;
        }
    }
}